<template>
  <div class="fancy-progress">
    <div class="shadow" :style="`background-color:${assignee.color}`"></div>
    <FancyProgressBarContent :name="assignee.value" :id="assignee.key" :icon="assignee.icon" :progress="assignee.progress" :color="assignee.color" />
    <!-- vase shadowye posht progressbar -->
  </div>
</template>

<script>
import FancyProgressBarContent from './FancyProgressBarContent'
import { teamTaskMixins } from '../../../utils/mixins'
export default {
  name: 'fancy-progressbar',
  mixins: [teamTaskMixins],
  components: {
    FancyProgressBarContent,
  },
  props: {
    progress: {
      type: Number,
    },
  },
 
}
</script>

<style lang='scss' scoped>
@import '../../../design/custom/components/_fancy_progressbar.scss';
</style>